import React from 'react';
import { Plus } from 'lucide-react';

export const FloatingAddButton = ({ onClick }) => {
  return (
    <button
      data-testid="floating-add-prospect-button"
      onClick={onClick}
      className="fixed bottom-8 right-8 h-14 w-14 rounded-full bg-[#E31837] text-white shadow-xl hover:bg-[#C4122C] hover:scale-105 transition-transform flex items-center justify-center z-50"
      aria-label="Add Prospect"
    >
      <Plus className="h-6 w-6" />
    </button>
  );
};
